'use client';

import useIsSeoFromDocumentReferrer from '@alltrails/networking/hooks/useIsSeoFromDocumentReferrer';
import { getItem } from '@alltrails/session-storage/utils';
import type DeeplinkData from '@alltrails/types/DeeplinkData';
import ScrollLimit from '@alltrails/user-auth/components/ScrollLimit/ScrollLimit';

type ScrollLimitWrapperProps = {
  isScrollLimitActive: boolean;
  deeplinkData: DeeplinkData;
};

export const isSessionSeoTraffic = (): boolean => {
  const sessionAttribution = getItem<{ referring_domain?: string }>('sessionAttribution');

  if (!sessionAttribution) {
    return false;
  }

  return sessionAttribution.referring_domain?.includes('google') ?? false;
};

const ScrollLimitWrapper = ({ isScrollLimitActive, deeplinkData }: ScrollLimitWrapperProps) => {
  const isSeoFromDocumentReferrer = useIsSeoFromDocumentReferrer();

  return isScrollLimitActive || isSessionSeoTraffic() || isSeoFromDocumentReferrer ? <ScrollLimit deeplinkData={deeplinkData} /> : null;
};

export default ScrollLimitWrapper;
